module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/vi_6-b23e4940fecdf6541e89b0383e4cf61c.jpg";